import { makeStyles } from '@mui/styles';
import { colors } from '@/styles/css/colors';

/**
 * Styles for the User Activity Dashboard page.
 * Follows the same `makeStyles` pattern used by `Header/header.styles.ts`
 * to keep styling conventions consistent across the codebase.
 */
const useUserActivityDashboardStyles = makeStyles({
  page: {
    display: 'flex',
    flexDirection: 'column',
    height: '100vh',
  },
  headerBar: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    padding: '12px 16px',
    borderBottom: '1px solid rgba(0,0,0,0.08)',
  },
  logo: {
    height: 24,
  },
  divider: {
    fontWeight: 700,
    fontSize: '1.25rem',
  },
  titleText: {
    fontWeight: 600,
    fontSize: '1.25rem',
  },
  spacer: {
    flex: 1,
  },
  headerIconButton: {
    transition: 'color 0.2s ease-in-out',
    '&:hover': {
      color: colors.PRIMARY,
    },
  },
  hoursSelect: {
    minWidth: 160,
  },
  content: {
    flex: '1 1 auto',
    minHeight: 0,
    overflowY: 'auto',
    padding: '24px',
  },
  centeredBox: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '60vh',
  },
  widgetStack: {
    display: 'flex',
    flexDirection: 'column',
    gap: '24px',
  },
  widgetPaper: {
    padding: '16px',
  },
  twoColumnRow: {
    display: 'flex',
    gap: '24px',
    flexWrap: 'wrap',
  },
  twoColumnItem: {
    flex: '1 1 420px',
  },
  threeColumnRow: {
    display: 'flex',
    gap: '16px',
    flexWrap: 'wrap',
  },
  threeColumnItem: {
    flex: '1 1 300px',
    minWidth: 280,
  },
  errorAlert: {
    marginBottom: '16px',
  },
});

export default useUserActivityDashboardStyles;
